<router-outlet></router-outlet>
<!-- Loading -->
<ng-template [ngIf]="(api.loading | async) || (api.loadingCustom | async)">
    <div class="spin_app">
        <div class="backdrop"></div>
        <nz-spin nzSimple [nzTip]="api.loadingTitle || 'Loading'" [nzSize]="'large'" [style]="spinnerStyle"></nz-spin>
    </div>
</ng-template>

